import Router, { Route } from 'vue-router';
import router from '@app/router/index';
import { isEmpty as _isEmpty } from 'lodash';
import { prepareAnalyticsScreenName } from '@app/utils/analyticsScreenNames';
import { marketingSourceService } from '@core/services/marketing/MarketingSourceService';

import { Analytics as AnalyticsSDK } from '@superbet-group/web.analytics.sdk';
import { TimeFilterSlug } from '@store/modules/ui/shared/timeFilter/utils';
import { Pageview } from '@superbet-group/product.analytics';

export async function sendRouteAnalytics(to: Route, from: Route): Promise<void> {
    await AnalyticsSDK.getInstance()
        .pageView(
            window.location.host + to.fullPath,
            // We add sports page view data to every page-view rather
            // than selectively, it'll only be populated for actual
            // sports page URLs though as otherwise we would not be able
            // to find the data at all.
            {
                name: 'pageview',
                sport: to.params.sportSlug || '',
                country: to.params.categorySlug || '',
                status: getMatchStatusFromRoute(to),
                match_type: '',
                tournament: to.params.tournamentSlug || '',
                match_id: String(to.query.e) || '',
            } as Pageview,
        );

    recordSuperAnalyticsPageVisit(to, from, router);
}

// Since this can happen on the initial page load. router.currentRoute is empty, and we have to use location.pathname
export async function marketingSourceTags(to: Route) {
    if (!_isEmpty(to.query)) {
        await marketingSourceService.handleMarketingQueryParams(to.query);
    }
}

export async function marketingAttributionTags(to: Route) {
    await marketingSourceService.handleMarketingAttributionQueryParams(to.query);
}

export function recordSuperAnalyticsPageVisit(to: Route, from: Route, router: Router) {
    if (to.meta?.superAnalytics === undefined) {
        return;
    }

    const currentScreenName = prepareAnalyticsScreenName(to, from);

    if (currentScreenName) {
        AnalyticsSDK.getInstance().log('session_screen_visit', {
            screen_name: currentScreenName,
        });
    }
}

function getMatchStatusFromRoute(route: Route) {
    return route.params.timeFilter === TimeFilterSlug.Live ? 'Live' : 'No_started';
}
